<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import modalAddCampaign from "../../../components/modals/merchandise/modalAddCampaign.vue";
    import modalEditCampaign from "../../../components/modals/merchandise/modalEditCampaign.vue";
    import modalLinkProductsToCampaign  from "../../../components/modals/merchandise/modalLinkProductsToCampaign.vue";
    import Swal from "sweetalert2";
    import Merchandising from "../../../services/Merchandising";

    export default {
        components: {
          Layout,
          PageHeader,
          modalAddCampaign,
          modalEditCampaign,
          modalLinkProductsToCampaign,
        },
        page: {
            title: "Campaigns",
            meta: [
                {
                    name: "description",
                    content: appConfig.description,
                },
            ],
        },
         data() {
            return {
                selectedCompanyData:null,
                isAuthorized: false,
                error: null,
                filterData: false,
                showMapData: false,
                showMap: false,
                tableData: [],
                title: "Campaigns",
                items: [
                    {
                        text: "Merchandising",

                    },
                    {
                        text: "Campaigns",
                        active: true,
                    },
                ],
                modalData:[],
                isBusy: false,
                totalRows: 0,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 25, 50, 100],
                filter: null,
                campaign_guid:'',
                campaign_name:'',
                campaign_status:'',
                products:[],
                modalProducts:[],
                filterOn: [],
                sortBy: "order",
                sortDesc: false,
                fields: [

                    {
                        key: "campaign_guid",
                        label: "Campaign GUID",
                        sortable: true,
                    },
                    {
                      key: "campaign_name",
                      label: "Campaign Name",
                      sortable: true,
                    },
                    {
                      key:"campaign_image",
                      label:"Campaign Image",
                      sortable:true
                    },
                    {
                        key: "date_from",
                        label: "Campaign Start Date",
                        sortable: true,
                    },
                    {
                      key:"date_to",
                      label:"Campaign End Date",
                      sortable:true
                    },
                    "action"
                ],
            };
        },

        methods: {
            openModalAddCampaign(){
                this.$bvModal.show("add_campaign");
            },
            openModalLinkProducts(campaign_guid,campaign_name,campaign_status,products){
                this.campaign_guid = campaign_guid;
                this.campaign_name = campaign_name;
                this.campaign_status = campaign_status;
                this.modalProducts = products;
                this.$bvModal.show("link_products_to_campaign");
            },
            openModalUpdateCampaign(data){
              this.modalData = data;
              this.$bvModal.show("edit_campaign");
            },


          async getMerchandiseCampaigns(){
                try {
                    this.filterData = true;
                    this.toggleBusy();

                    const response = await Merchandising.getMerchandiseCampaigns()
                    this.tableData = response.data.data
                    this.totalRows = this.tableData.length
                } catch (error) {
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.tableData = []
                    this.totalRows = 0;
                } finally {
                    this.toggleBusy();
                }
            },



          async removeCampaign(campaign_guid) {
            Swal.fire({
              title: "Remove Campaign?",
              text: "This campaign will be deleted!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: "Delete!",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        const response = await Merchandising.removeCampaign(campaign_guid);
                        if (response.data.data) {
                          Swal.fire("Success!", "Campaign is successfully deleted !", "success");
                          await  this.getMerchandiseCampaigns();
                        } else {
                            let errorMessage = response.error ? response.error : 'Failed';
                            if (typeof errorMessage === 'object') {
                                errorMessage = errorMessage[0];
                            }
                            Swal.fire("Fail!", errorMessage, "warning");
                        }
                    } catch (error) {
                        let errorMessage = error.response && error.response.data && error.response.data.error
                            ? error.response.data.error
                            : "An error occurred while deleting campaign!";
                        if (typeof errorMessage === 'object') {
                          errorMessage = errorMessage[0];
                        }
                        Swal.fire("Error", errorMessage, "error");
                    }
                }
            });
          },

        },
        mounted() {
            this.getMerchandiseCampaigns();
        },
        middleware: "authentication",
    };
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items"/>
        <div class="row">
            <div class="col-12">

                <div class="card">
                    <div class="card-body">
                            <div>
                                <a href="javascript:void(0);" @click="openModalAddCampaign" class="btn btn-success waves-effect waves-light me-3">
                                    <i class="mdi mdi-plus me-2"></i>
                                    Add New Campaign
                                </a>
                            </div>
                        <div class="row mt-2">
                            <div class="col d-inline-flex align-items-center" >
                                <h4 class="card-title m-0">Total Campaigns: {{totalRows}}</h4>
                            </div>
                        </div>


                        <div class="row mt-4" v-show="filterData">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Show&nbsp;
                                        <b-form-select
                                            v-model="perPage"
                                            size="sm"
                                            :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div
                                    id="tickets-table_filter"
                                    class="dataTables_filter text-md-end"
                                >
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                            v-model="filter"
                                            type="search"
                                            placeholder="Search..."
                                            class="form-control form-control-sm ms-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0" v-show="filterData">
                            <b-table
                                :items="tableData"
                                :busy="isBusy"
                                :fields="fields"
                                responsive="sm"
                                :per-page="perPage"
                                :current-page="currentPage"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :filter="filter"
                                :filter-included-fields="filterOn"
                                show-empty
                                empty-text="No Data Found"
                            >
                               

                                <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                    </div>
                                </template>
                              <template  v-slot:cell(campaign_image)="data">
                                 <img v-if="data.item.campaign_image" :src="data.item.campaign_image" style="width: 100px;" alt="image"/>
                              </template>
                                <template  v-slot:cell(date_from)="data">
                                  <span class="badge font-size-14" :class="{
                                    'bg-success': data.item.status === 'active',
                                    'bg-danger': data.item.status === 'ended',
                                    'bg-warning': data.item.status === 'future'
                                  }" >{{data.item.date_from}}</span>
                                </template>
                              <template  v-slot:cell(date_to)="data">
                                  <span class="badge font-size-14" :class="{
                                    'bg-success': data.item.status === 'active',
                                    'bg-danger': data.item.status === 'ended',
                                    'bg-warning': data.item.status === 'future'
                                  }" >{{data.item.date_to}}</span>
                              </template>



                              <!--                                <template  v-slot:cell(terms)="data">-->
<!--                                  <span>{{ Object.keys(data.item.terms).length }}</span>-->
<!--                                </template>-->

<!--                              <template  v-slot:cell(categories)="data">-->
<!--                                <span>{{ Object.keys(data.item.categories).length }}</span>-->
<!--                              </template>-->
                                <template v-slot:cell(action)="data">
                                    <ul class="list-inline mb-0 ">
                                        <li class="list-inline-item">
                                            <a href="javascript:void(0)" @click="openModalLinkProducts(data.item.campaign_guid,data.item.campaign_name,data.item.campaign_status,products)" title="Link Products to Campaign">
                                              <i class="uil uil-link px-2 font-size-18"></i>
                                            </a>
                                        </li>
                                        <li class="list-inline-item">
                                          <a  href="javascript:void(0);" class="px-2 text-black" title="Edit Campaign" @click="
                                          openModalUpdateCampaign(data.item)
                                          ">
                                            <i class="fas fa-pen font-size-14 text-primary" ></i>
                                          </a>
                                      </li>
                                      <li class="list-inline-item">
                                        <a  href="javascript:void(0);" class="px-2 text-black" title="Remove Campaign" @click="removeCampaign(data.item.campaign_guid)">
                                          <i class="uil uil-trash-alt font-size-18 text-danger" ></i>
                                        </a>
                                      </li>
                                    </ul>
                                </template>
                            </b-table>
                        </div>
                        <div class="row" v-show="filterData">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination
                                            v-model="currentPage"
                                            :total-rows="totalRows"
                                            :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

  <modalAddCampaign @onRefresh="getMerchandiseCampaigns"></modalAddCampaign>
  <modalEditCampaign @onRefresh="getMerchandiseCampaigns" :campaignData="modalData"></modalEditCampaign>
  <modalLinkProductsToCampaign @onRefresh="getMerchandiseCampaigns" :id="campaign_guid" :name="campaign_name" :status="campaign_status" :products="modalProducts" ></modalLinkProductsToCampaign>
    </Layout>
</template>
<style>

</style>